import { useEffect, useRef } from 'react';

const useScrollToElement = ({
  elementIdToScroll,
  scrollTrigger,
  behavior = 'instant',
  block = 'start',
}) => {
  const ref = useRef(null);

  const scrollToElement = () => {
    if (ref.current && ref.current.id === elementIdToScroll.toLowerCase()) {
      ref.current.scrollIntoView({
        behavior,
        block,
      });
    }
  };

  useEffect(() => {
    if (elementIdToScroll) {
      requestAnimationFrame(scrollToElement);
    }
  }, [elementIdToScroll, scrollTrigger]);

  return [ref];
};

export default useScrollToElement;
